module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Dotzigen_BE_COA-6731cddd6c3ade653c960a2327436324.svg";